import React from "react";
import "./index.scss";
import * as actions from "./../../../modules/booking/actions";
import * as settingActions from "./../../../modules/setting/actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import LightCalendar from "../../shared/light-calendar";
import { CITY_BOOKING, GOURMET } from "../../../constants/app";

let CHILD_ROUTES = ["/setting/common", "/setting/menu", "/setting/discount"];

class NavigationPanel extends React.Component {
  constructor(props) {
    super(props);
    this.isGourmet = this.props.auth.user.category_type === GOURMET;
    this.isCityBooking = this.props.auth.user.city_name === CITY_BOOKING;
    this.state = {
      chosenDate: new Date(),
    };
  }

  componentDidMount() {
    const { currentRoute } = this.props;
    const shopType = this.props.auth.user.category_type;
    const cityName = this.props.auth.user.city_name;
    if (shopType === GOURMET && cityName === CITY_BOOKING) {
      CHILD_ROUTES.push.apply(CHILD_ROUTES, [
        "/setting/table",
        "/setting/participants",
      ]);
    } else {
      CHILD_ROUTES.push("/setting/staff");
    }
    this.transformArrow();
    if (CHILD_ROUTES.includes(currentRoute.path)) {
      this.showCollapse();
    }

    this.loadInitialData();

    this.unlistener = this.props.history.listen(() => {
      this.loadInitialData();
    });
  }

  loadInitialData() {
    const { dispatchActions } = this.props;
    const shopId = this.props.auth.user.id;
    dispatchActions.getListMenu(shopId);
    if (this.isGourmet) {
      dispatchActions.getListTable({
        shopId,
        query: {
          page_size: 20,
          page: 1,
        },
      });
      dispatchActions.getListParticipants(shopId);
    } else {
      dispatchActions.getListStaff(shopId);
    }
  }

  showCollapse() {
    const myCollapse = document.getElementById("collapse-controller");
    myCollapse.click();
  }

  transformArrow() {
    const collapseAreaNode = document.getElementById("collapse-area");
    const arrowNode = document.getElementById("chevron-icon");

    collapseAreaNode.addEventListener("show.bs.collapse", () => {
      arrowNode.classList.remove("rotate-down");
      arrowNode.classList.add("rotate-right");
    });

    collapseAreaNode.addEventListener("hide.bs.collapse", () => {
      arrowNode.classList.remove("rotate-right");
      arrowNode.classList.add("rotate-down");
    });
  }

  changePath = (path) => {
    if (window.innerWidth <= 900) {
      const checkbox = document.getElementById("check");
      checkbox.checked = !checkbox.checked;
    }
    this.props.history.push(path);
  };

  onSidebarBlur = () => {
    if (window.innerWidth <= 900) {
      const checkbox = document.getElementById("check");
      if (checkbox.checked) {
        checkbox.checked = false;
      }
    }
  };

  onChangeDate = (date) => {
    this.props.dispatchActions.setSimpleCalendarChosenDate(date);
    const checkbox = document.getElementById("check");
    checkbox.checked = false;
  };

  render() {
    const { currentRoute, auth } = this.props;
    const { onChangeDate, onSidebarBlur, isGourmet, isCityBooking } = this;
    const showMenu = auth.user.show_menu;
    const showStaff = auth.user.show_staff;
    const showTable = auth.user.show_tables;
    return (
      <div tabIndex="1" onBlur={onSidebarBlur}>
        <input
          className="navigation-panel__toggle-button"
          type="checkbox"
          id="check"
          style={{ display: "none" }}
        />
        <label
          className="navigation-panel__toggle-button material-icons"
          htmlFor="check"
        >
          menu
        </label>
        <div
          className="navigation-panel__overlay"
          onClick={onSidebarBlur}
        ></div>
        <div
          id="navigation-panel"
          className={[
            "navigation-panel",
            this.props.show ? "navigation-show" : "",
          ].join(" ")}
        >
          <h2 className="navigation-panel__shop-name">{this.props.title}</h2>
          <ul className="navigation-panel__options options">
            <li
              className="options__item schedule"
              onClick={() => this.changePath("/booking")}
            >
              <span
                role="button"
                // href="/booking"
                className={
                  currentRoute.path === "/booking" ? "navigation-active" : ""
                }
              >
                <i className="fas fa-calendar-alt me-2"></i>
                <p className="d-inline-block">カレンダー</p>
              </span>
            </li>
            <li className="options__item position-relative">
              <span
                id="collapse-controller"
                className="d-block"
                data-bs-toggle="collapse"
                href="#collapse-area"
                role="button"
                aria-expanded="false"
                aria-controls="collapse-area"
              >
                <i className="fas fa-cogs me-2"></i>設定
                <i
                  id="chevron-icon"
                  className="fas fa-chevron-down chevron-icon"
                ></i>
              </span>
              <ul className="collapse" id="collapse-area">
                {((showStaff && !isGourmet) || !isCityBooking) && (
                  <li
                    role="button"
                    onClick={() => this.changePath("/setting/staff")}
                    className="navigation-panel__staff"
                  >
                    <span
                      className={
                        currentRoute.path === "/setting/staff"
                          ? "navigation-active"
                          : ""
                      }
                    >
                      <i className="fas fa-cog me-2"></i>
                      <span>
                        {window.store.getState().auth.user.section_name_1}
                      </span>
                    </span>
                  </li>
                )}
                {showTable && isGourmet && isCityBooking && (
                  <>
                    <li
                      role="button"
                      onClick={() => this.changePath("/setting/table")}
                    >
                      <span
                        className={
                          currentRoute.path === "/setting/table"
                            ? "navigation-active"
                            : ""
                        }
                      >
                        <i className="fas fa-cog me-2"></i>席
                      </span>
                    </li>

                    <li
                      role="button"
                      onClick={() => this.changePath("/setting/participants")}
                    >
                      <span
                        className={
                          currentRoute.path === "/setting/participants"
                            ? "navigation-active"
                            : ""
                        }
                      >
                        <i className="fas fa-cog me-2"></i>人数
                      </span>
                    </li>
                  </>
                )}
                {(showMenu || !isCityBooking) && (
                  <li
                    role="button"
                    onClick={() => this.changePath("/setting/menu")}
                  >
                    <span
                      className={
                        currentRoute.path === "/setting/menu"
                          ? "navigation-active"
                          : ""
                      }
                    >
                      <i className="fas fa-cog me-2"></i>メニュー
                    </span>
                  </li>
                )}
                <li
                  role="button"
                  onClick={() => this.changePath("/setting/discount")}
                >
                  <span
                    className={
                      currentRoute.path === "/setting/discount"
                        ? "navigation-active"
                        : ""
                    }
                  >
                    <i className="fas fa-cog me-2"></i>割引
                  </span>
                </li>
                <li
                  role="button"
                  onClick={() => this.changePath("/setting/common")}
                >
                  <span
                    className={
                      currentRoute.path === "/setting/common"
                        ? "navigation-active"
                        : ""
                    }
                  >
                    <i className="fas fa-cog me-2"></i>共通
                  </span>
                </li>
              </ul>
            </li>
            <li
              className="options__item"
              onClick={() => this.changePath("/history")}
            >
              <span
                role="button"
                // href="/history"
                className={
                  currentRoute.path === "/history" ? "navigation-active" : ""
                }
              >
                <i className="fas fa-history me-2"></i>
                <span>履歴</span>
              </span>
            </li>
            {isCityBooking && (
              <li
                className="options__item"
                role="button"
                onClick={() => this.changePath("/customer")}
              >
                <span
                  className={
                    currentRoute.path === "/customer" ? "navigation-active" : ""
                  }
                >
                  <i className="fas fa-cog me-2"></i>ユーザー一覧
                </span>
              </li>
            )}
            {showTable && isGourmet && isCityBooking && (
              <li
                className="options__item"
                role="button"
                onClick={() => this.changePath("/available-table")}
              >
                <span
                  className={
                    currentRoute.path === "/available-table"
                      ? "navigation-active"
                      : ""
                  }
                >
                  <i className="fas fa-cog me-2"></i>空席管理画面
                </span>
              </li>
            )}
          </ul>
          {this.props.history.location.pathname === "/booking" &&
          this.props.setting.listMenu.length &&
          this.props.setting.listStaff.length ? (
            <div className="navigation-panel__calendar">
              <LightCalendar
                chosenDate={
                  this.props.booking.simpleCalendarChosenDate || new Date()
                }
                disableNotCurrentMonth={false}
                onClick={onChangeDate}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    booking: state.booking,
    setting: state.setting,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchActions: bindActionCreators(
    { ...actions, ...settingActions },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavigationPanel);
